import type { Theme } from "@/types/config/theme";

import { themeMap } from "@/types/config/theme";
import { isDev } from "@/lib/env";

const bannedHostnames = ["truthpuke.com"];
const ddhqHostnames = ["e.ddhq.io", "ddhq.io", "decisiondeskhq.com"];
const whitelistedThemes: Theme[] = ["ddhq", "ddhq-dark", "the-hill", "the-hill-editorial"];

export function isValidHostname(hostname: string, theme: Theme): boolean {
  if (isDev) return true;
  if (bannedHostnames.includes(hostname)) return false;
  if (ddhqHostnames.includes(hostname)) return true;
  if (whitelistedThemes.includes(theme)) return true;

  const matchingTheme = themeMap.find((findTheme) => {
    return findTheme.value === theme;
  });

  if (!matchingTheme) return false;

  const hostnames = matchingTheme.domains as unknown as string[];

  return hostnames.includes(hostname);
}
